import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const initialState = {
  internalLinks: [],
  modelInternalLinks: [],
  popstate: false,
  isLoading: false,
  hasErrored: false,
  data: [],
  total: 0,
  currentFilters: {},
  searchLabels: [],
  searchPath: '/cars',
  currency: '',
}

export const itemsFetchData = createAsyncThunk(
  'items/itemsFetchData',
  ({ filters = {}, options = {} }) => {
    filters.search_session_id = App.State.searchSessionId

    if (options.currency) {
      filters.currency = options.currency
    }

    if (typeof App.State.userCoordinates !== 'undefined') {
      filters.user_coordinates = App.State.userCoordinates
    }

    return App.Request.post('/cars/search.json', filters)
  },
  {}
)

export const itemsSlice = createSlice({
  name: 'items',
  initialState,
  extraReducers: {
    [itemsFetchData.pending]: (state) => ({
      ...state,
      isLoading: true,
      hasErrored: false,
      data: [],
    }),
    [itemsFetchData.rejected]: (state) => ({
      ...state,
      isLoading: false,
      hasErrored: true,
      data: [],
    }),
    [itemsFetchData.fulfilled]: (state, action) => {
      const { data } = action.payload

      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        data: data.cars,
        premiumCars: data.premiumCars,
        total: data.total,
        prettyTotal: data.prettyTotal,
        structuredSearchData: data.structuredSearchData,
        currentFilters: data.currentFilters,
        searchLabels: data.searchLabels,
        description: data.description,
        pageTitle: data.pageTitle,
        headTitle: data.headTitle,
        footerTitle: data.footerTitle,
        showCarousel: data.showCarousel,
        footerDescription: data.footerDescription,
        seoUpdatedAt: data.seoUpdatedAt,
        videoUrl: data.videoUrl,
        faq: data.faq,
        metaDescription: data.metaDescription,
        similarPosts: data.similarPosts,
        tag: data.tag,
        popstate: data.popstate,
        searchPath: data.searchPath,
        currency: data.currency,
        internalLinks: data.internalLinks,
        modelInternalLinks: data.modelInternalLinks,
        manufacturerTitle: data.manufacturerTitle,
        modelTitle: data.modelTitle,
        currentMileage: data.currentMileage,
      }
    },
  },
})

export default itemsSlice.reducer
